"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntimidationOfTheKingAbilityHandler = exports.IntimidationOfTheKingActorAbilityFactory = exports.IntimidationOfTheKingAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/effects/core");
class IntimidationOfTheKingAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.IntimidationOfTheKing;
        this.__typeName = "IntimidationOfTheKing";
    }
}
exports.IntimidationOfTheKingAbilityArgs = IntimidationOfTheKingAbilityArgs;
let IntimidationOfTheKingActorAbilityFactory = class IntimidationOfTheKingActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("IntimidationOfTheKing", "AllEnemies", 0);
    }
};
IntimidationOfTheKingActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("IntimidationOfTheKing")
], IntimidationOfTheKingActorAbilityFactory);
exports.IntimidationOfTheKingActorAbilityFactory = IntimidationOfTheKingActorAbilityFactory;
let IntimidationOfTheKingAbilityHandler = class IntimidationOfTheKingAbilityHandler {
    init(sequence, container, actorId) {
        sequence = sequence.pushSequence("parallel");
        container.selectLivingTargets(actorId, Target_1.Target.AllEnemies)
            .forEach(enemy => {
            container.applyDebuff({
                sequence,
                attackerId: actorId,
                targetId: enemy,
                duration: Duration_1.Duration.Permanent,
                effect: new core_1.LinkedEffectsEffectArgs(Array.from(enums_1.PRIMARY_ATTRIBUTES).map(attr => new core_1.MaxAttributeDecreaseEffectArgs(attr, container.getPercentOfBaseAttributeScore(enemy, 5, attr))), true),
            });
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
IntimidationOfTheKingAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.IntimidationOfTheKing)
], IntimidationOfTheKingAbilityHandler);
exports.IntimidationOfTheKingAbilityHandler = IntimidationOfTheKingAbilityHandler;
